import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import warning from "../../images/warning.svg";

export default function DraftsRevokeModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete",
  description = "Are you sure you want to delete this item?",
  confirmButtonText = "Delete",
  cancelButtonText = "Cancel",
  confirmButtonColor = "bg-red-600 hover:bg-red-800",
  icon = warning,
}) {
  function closeModal(e) {
    if (e) e.stopPropagation();
    onClose();
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className="fixed inset-0 bg-black/25 backdrop-blur-md"
              onClick={closeModal}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') closeModal(e); }}
              role="button"
              tabIndex={0}
            />
          </Transition.Child>

          <div
            className="fixed inset-0 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.stopPropagation(); }}
            role="button"
            tabIndex={0}
          >
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all relative">
                  <button
                    type="button"
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-500 focus:outline-none"
                    onClick={closeModal}
                  >
                    <span className="sr-only">Close</span>
                    &#10005;
                  </button>

                  <Dialog.Title
                    as="h3"
                    className="text-lg flex justify-center font-medium leading-6 text-gray-900"
                  >
                    {icon && <img src={icon} alt="warning" />}
                  </Dialog.Title>
                  <div className="mt-2 ">
                    <p className="text-lg font-medium flex justify-center">
                      {title}
                    </p>
                    <p className="text-sm text-gray-500 mt-2 flex justify-center">
                      {description}
                    </p>
                  </div>

                  <div className="mt-4 flex justify-between">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-3 focus:ring-gray-100"
                    >
                      {cancelButtonText}
                    </button>
                    <button
                      type="button"
                      onClick={onConfirm}
                      className={`text-white focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center ${confirmButtonColor}`}
                    >
                      {confirmButtonText}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
